import { render, staticRenderFns } from "./RecordSettingPanel.vue?vue&type=template&id=68a09920&scoped=true"
import script from "./RecordSettingPanel.vue?vue&type=script&lang=ts"
export * from "./RecordSettingPanel.vue?vue&type=script&lang=ts"
import style0 from "./RecordSettingPanel.vue?vue&type=style&index=0&id=68a09920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a09920",
  null
  
)

export default component.exports